// extracted by mini-css-extract-plugin
module.exports = {"title":"Header_title__IN83T","globalError":"Header_globalError__cU7Dr"};